var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"maintenance-placeholder text-center\">\n<span class=\"icon icon-check-smiley-sad maintenance-placeholder-icon\"></span>\n<p>\n<strong class=\"maintenance-placeholder-heading\" translate translate-comment=\"{{$ctrl.elementName}} on poissa käytöstä olevan elementin nimi, esimerkiksi 'Ajanvaraus', 'OmaOral'.\">{{$ctrl.elementName}} ei valitettavasti ole käytettävissä huoltotilan aikana.</strong>\n</p>\n<p translate>Pahoittelemme mahdollista haittaa.</p>\n</div>\n";
var id1="app/common/keepalive/maintenance-placeholder.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/keepalive/maintenance-placeholder.tpl.html
// module id = 496
// module chunks = 0